import { ActionSet, createActionSet } from '../../redux-helpers';

export const GET_WORKSPACES: ActionSet = createActionSet('GET_WORKSPACES');
export const GET_ALL_WORKSPACES_DATA: ActionSet = createActionSet('GET_ALL_WORKSPACES_DATA');
export const GET_ALL_WORKSPACE_CONSOLIDATIONS: ActionSet = createActionSet('GET_ALL_WORKSPACE_CONSOLIDATIONS');
export const GET_WORKSPACE_BY_ID: ActionSet = createActionSet('GET_WORKSPACE_BY_ID');
export const GET_WORKSPACE_PERMISSIONS: ActionSet = createActionSet('GET_WORKSPACE_PERMISSIONS');
export const CREATE_WORKSPACE: ActionSet = createActionSet('CREATE_WORKSPACE');
